var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactIconLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 0.625C12.7148 0.625 13.125 1.03516 13.125 1.52734V12C13.125 12.4922 12.7148 12.875 12.25 12.875H1.72266C1.25781 12.875 0.875 12.4922 0.875 12V1.52734C0.875 1.03516 1.25781 0.625 1.72266 0.625H12.25ZM4.56641 11.125V5.30078H2.76172V11.125H4.56641ZM3.66406 4.48047C4.23828 4.48047 4.70312 4.01562 4.70312 3.44141C4.70312 2.86719 4.23828 2.375 3.66406 2.375C3.0625 2.375 2.59766 2.86719 2.59766 3.44141C2.59766 4.01562 3.0625 4.48047 3.66406 4.48047ZM11.375 11.125V7.92578C11.375 6.36719 11.0195 5.13672 9.1875 5.13672C8.3125 5.13672 7.71094 5.62891 7.46484 6.09375H7.4375V5.30078H5.71484V11.125H7.51953V8.25391C7.51953 7.48828 7.65625 6.75 8.61328 6.75C9.54297 6.75 9.54297 7.625 9.54297 8.28125V11.125H11.375Z",
    fill: "#8791B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIconLinkedin);
export default __webpack_public_path__ + "static/media/contact-icon-linkedin.b38501d657e7471feab35424ad79c1f8.svg";
export { ForwardRef as ReactComponent };